import { BaseInput } from './base-input';

export class TextboxUrlInput extends BaseInput {
  public constructor(data: any) {
    super(data);
  }
}
